import type { Step as RcStep } from '@sb/remote-control/types';

import type { Diagnostic, ValidationRule } from '../../types';
import {
  catchActionRequiredToDiagnostic,
  createStepRule,
} from '../../util/ruleHelpers';
import { validateConditional } from '../../util/validators';

/**
 * Validate ElseIf's `condition` field. Block-connection ("ElseIf must follow
 * an If or another ElseIf") is handled by the `conditional.orphanedElseBlock`
 * common rule in `Suppressed.ts`, which also accounts for suppressed
 * siblings — so this rule only covers the condition contents.
 */
export const ElseIfValidation: ValidationRule = createStepRule({
  id: 'steps.ElseIf',
  stepKinds: ['ElseIf'],
  run: ({ routine, stepId }): Diagnostic[] => {
    const stepCfg = routine.stepConfigurations[stepId];
    if (!stepCfg) return [];

    const args = stepCfg.args as RcStep.Arguments & { condition?: string };
    if (args.condition == null) return [];

    try {
      const conditions = JSON.parse(args.condition || '[]');
      validateConditional(conditions, routine);
    } catch (err) {
      return catchActionRequiredToDiagnostic(err, stepId, 'steps.ElseIf');
    }

    return [];
  },
});
